module.exports = __webpack_public_path__ + "img/in.fd8e9111.svg";